module.exports = __webpack_public_path__ + "img/1.be0369d7.jpeg";